(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/payment-context.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/payment-context.js');
"use strict";

const _React = React,
  createContext = _React.createContext;
const PaymentContext = createContext();
setGlobal('svs.components.tipsen.couponId.PaymentContext', PaymentContext);

 })(window);